module.exports = __webpack_public_path__ + "static/img/senlinwuhui.6481503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/senlinwuhui.jpg
// module id = 8kkO
// module chunks = 0